import React from 'react';
import { FaCalendarAlt, FaClock } from 'react-icons/fa';
import './GrcWebinarCarouselSlide.css';
import grcWebinarBg from '../../assets/Products/GRC/GRCS.jpg';
import gopaSirPhoto from '../../assets/Home/GopaSir.JPG';

const REGISTER_URL = 'https://events.teams.microsoft.com/event/2f5971f1-6b07-41a1-ad93-5a3b261a1073@aa7c8c45-41a3-4453-bc9a-3adfe8ff5fb6?source=copyLinkOneEventsShareDialog';

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12h14M13 5l7 7-7 7" />
  </svg>
);

const GrcWebinarCarouselSlide = () => (
  <div className="grc-webinar-slide" role="img" aria-label="Vardaan Webinar Series — AI-Enabled GRC live webinar on 12 November 2026">
    <div className="grc-webinar-bg" style={{ backgroundImage: `url(${grcWebinarBg})` }} aria-hidden="true" />
    <div className="grc-webinar-scrim" aria-hidden="true" />

    <div className="grc-webinar-stamp">
      <span><span className="grc-webinar-accent">●</span>&nbsp;&nbsp;Vardaan Webinar Series</span>
      <span>Governance · Risk · Compliance · AI</span>
    </div>

    <div className="grc-webinar-date">
      <span>Live Webinar · 01 of 06</span>
      <span className="grc-webinar-date-big">Thu, 12 November 2026</span>
    </div>

    <div className="grc-webinar-content">
      <h2 className="grc-webinar-headline">
        AI-Enabled <em>GRC</em>
      </h2>

      <p className="grc-webinar-subline">
        Practical Applications Across Risk, Compliance and Audit
      </p>

      <div className="grc-webinar-meta">
        <span className="grc-webinar-meta-item">
          <FaCalendarAlt aria-hidden="true" />
          Thu, 12 November 2026
        </span>
        <span className="grc-webinar-meta-divider" aria-hidden="true" />
        <span className="grc-webinar-meta-item">
          <FaClock aria-hidden="true" />
          3:00 – 4:00 PM IST
        </span>
      </div>

      <div className="grc-webinar-speaker">
        <img className="grc-webinar-speaker-photo" src={gopaSirPhoto} alt="Gopakumar N Kavunkal" />
        <div className="grc-webinar-speaker-text">
          <div className="grc-webinar-speaker-label">Featuring</div>
          <div className="grc-webinar-speaker-name">Gopakumar N Kavunkal</div>
          <div className="grc-webinar-speaker-role">Chief Executive Officer · Vardaan Data Sciences Pvt. Ltd.</div>
          <div className="grc-webinar-speaker-platform">Live online on Microsoft Teams</div>
        </div>
      </div>

      <p className="grc-webinar-tagline">Make your next move in GRC.</p>

      <a
        href={REGISTER_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="grc-webinar-cta"
        onClick={(e) => e.stopPropagation()}
      >
        Register Now
        <ArrowIcon />
      </a>
    </div>

    <div className="grc-webinar-signature">
      <span className="grc-webinar-brand">Vardaan</span> &nbsp;·&nbsp; Data Sciences
    </div>

    <div className="grc-webinar-location">
      Be part of the conversation.<br />
      3:00 – 4:00 PM IST · Microsoft Teams
    </div>
  </div>
);

export default GrcWebinarCarouselSlide;
